import { type ReactNode } from "react";
import { SpaceBackdrop } from "@/components/marketing/site/space-backdrop";
import { MarketingNav } from "@/components/marketing/site/marketing-shell-marketing-nav";
import { MarketingFooter } from "@/components/marketing/site/marketing-shell-marketing-footer";
import { useSiteBase } from "@/lib/marketing/site-version-shared";

/** `sky` off for a page that brings its own (the home page's cosmos stage). */
export function MarketingShell({ children, sky = true }: { children: ReactNode; sky?: boolean }) {
  /* Only the site's arm loads the sheet that pins the sky behind the page; outside it (/legal) the
     sky would stand in the page as a screen-high block above the text. */
  const inArm = useSiteBase() !== "";
  return (
    /* `ac-root` sets the Ocean Breeze face, tabular figures and surface colors explicitly, and no
     * font-size so the brand scale stays; the tabular numerals are for pricing tables. */
    <div className="ac-root min-h-dvh font-ui">
      {sky && inArm ? <SpaceBackdrop /> : null}
      <MarketingNav />
      <main>{children}</main>
      <MarketingFooter />
    </div>
  );
}
